/**
 * Përkthimet Shqip / English – krejt tekstit e aplikacionit
 */
export const translations = {
  sq: {
    // Layout & Nav (ekzistojnë)
    logout: 'Dil',
    more: 'Më shumë',
    home: 'Paneli',
    devices: 'Pajisjet',
    alarms: 'Alarmet',
    reports: 'Raportet',
    kosova: 'Kosova',
    fleet_overview: "Pamja Live",
    analysis: 'Analiza',
    analizat: 'Analizat',
    planning: 'Planifikimi',
    control: 'Kontroll',
    companies: 'Kompanitë',
    users: 'Përdoruesit',
    une: 'Unë',
    navKosova: 'KOSOVA',
    systemSettings: 'Cilësimet e sistemit',
    connections: 'Lidhjet',
    about: 'Rreth',
    aboutApp: 'Rreth aplikacionit',
    connectionsHint: 'Statusi i lidhjeve dhe dokumentacioni i integrimit.',
    changePassword: 'Ndrysho fjalëkalimin',
    currentPassword: 'Fjalëkalimi aktual',
    newPassword: 'Fjalëkalim i ri',
    confirmNewPassword: 'Konfirmo fjalëkalimin',
    passwordChanged: 'Fjalëkalimi u ndryshua.',
    passwordChangeError: 'Nuk u ndryshua fjalëkalimi.',
    passwordMismatch: 'Fjalëkalimet e reja nuk përputhen.',
    languageLabel: 'Gjuha',
    themeLabel: 'Pamja',
    themeDark: 'E errët',
    themeLight: 'E ndritur',

    // Login
    loginTitle: 'Kyçu',
    loginSubtitle: 'Shkruaj kredencialet për të vazhduar',
    username: 'Përdoruesi',
    passwordLabel: 'Fjalëkalimi',
    rememberCreds: 'Ruaj kredencialet',
    loginBtn: 'Kyçu',
    loggingIn: 'Duke u kyçur...',
    errorNetwork: 'Lidhja me serverin dështoi.',
    errorLogin: 'Gabim gjatë kyçjes. Provoni përsëri.',
    toggleThemeLabel: 'Ndrysho light/dark',

    // Common
    loading: 'Duke ngarkuar...',
    cancel: 'Anulo',
    save: 'Ruaj',
    close: 'Mbyll',
    delete: 'Fshi',
    edit: 'Ndrysho',
    add: 'Shto',
    apply: 'Apliko',
    search: 'Kerko',
    back: 'Kthehu',
    confirm: 'A je i sigurt?',
    errorGeneric: 'Gabim',
    password: 'Fjalëkalim',
    confirmCheck: 'Konfirmoj',
    execute: 'Ekzekuto',
    sending: 'Duke dërguar...',
    noCompanies: 'Nuk ka kompani',
    selectCompany: 'Zgjidh kompaninë',
    selectCompanyFirst: 'Zgjidhni një kompani.',
    company: 'Kompani',
    dataLogger: 'Regjistrues i Të Dhënave',
    dataLoggers: 'Regjistruesit e Të Dhënave',
    inverter: 'Inverter',
    inverters: 'Inverterët',
    energyMeter: 'Njehsor Energjie',
    energyMeters: 'Njehsorët e Energjisë',
    status: 'Statusi',
    type: 'Lloji',
    actions: 'Veprime',
    online: 'Online',
    offline: 'Offline',
    partial: 'Pjesërisht',
    normal: 'Normal',
    active: 'Aktive',
    inactive: 'Joaktive',
    total: 'Total',
    day: 'Dita',
    month: 'Muaji',
    year: 'Viti',
    week: 'Java',
    today: 'Sot',
    yesterday: 'Dje',
    tomorrow: 'Nesër',
    noData: 'Nuk ka të dhëna',

    emPowerFlowTitle: 'Rrjedhja e energjisë',
    emPowerFlowPpv: 'Ppv',
    emPowerFlowBattery: 'Fuqia e shkarkimit',
    emPowerFlowLoad: 'Fuqia e ngarkesës',
    emPowerFlowGridImport: 'Import',
    emPowerFlowExportTag: 'EKSPORT',
    emPowerFlowUnitKw: 'kW',
    emPowerFlowUnitMw: 'MW',

    // Control (ekzistojnë)
    controlDatalogger: 'Kontroll Datalogger',
    controlSubtitle: 'Zgjidhni kompaninë, data logger dhe kontrollin.',
    selectDataLogger: 'Zgjidh data logger',
    start: 'Start',
    stop: 'Stop',
    shutdown: 'Shutdown',
    enable: 'Enable',
    controlLabel: 'Kontrolli',
    limitProduction: 'Kufizo prodhimin',
    reactivePower: 'Reactive Power (kVar)',
    powerFactor: 'Power Factor (cosφ)',
    reactiveMode: 'Mënyra reaktive (Q / PF)',
    current: 'Aktual',
    applyQ: 'Apliko Q',
    applyPF: 'Apliko PF',
    applyMode: 'Apliko mënyrën',
    mode: 'Mode',
    disabled: 'Disabled',
    percent: 'Percent',
    kw: 'kW',
    qKvar: 'Q (kVar)',
    pfCos: 'PF (cosφ)',
    voltVar: 'Volt-Var',
    voltWatt: 'Volt-Watt',
    inverterList: 'Lista e inverterëve',
    selectAll: 'Select All',
    noInverters: 'Nuk ka inverterë.',
    selectDataLoggerFirst: 'Zgjidh data logger.',

    // Dashboard
    noCompaniesDash: 'No companies',
    noDataLoggers: 'No Data Loggers',
    addDataLoggerHint: 'Shto një data logger për këtë kompani',
    co2Today: 'CO2 Today',
    pvNow: 'PV Now',
    pvToday: 'PV Today',
    pvYesterday: 'PV Yesterday',
    todayProfit: "Today's Profit",
    updated: 'Përditësuar',
    justNow: 'just now',
    onGrid: 'ON GRID',
    offGrid: 'OFF GRID',
    flowing: 'në rrjedhje',
    production7days: 'Production 7 days (kWh)',
    energyFlow: 'Energy Flow',
    pv: 'PV',
    load: 'Load',
    grid: 'Grid',
    production: 'Production',
    solar: 'Solar',
    pvPower: 'PV Power',
    capacity: 'Capacity',
    dayShort: 'Dita',
    monthShort: 'Muaji',
    yearShort: 'Viti',
    thisMonth: 'Këtë Muaj',
    thisYear: 'Këtë Vit',
    totalProduction: 'Total Production',
    urgentAlarms: 'Alarmet urgjente',
    recentAlarms: 'Alarmet e fundit',
    environmentalImpact: 'Impakti Mjedisor',
    co2TodayLabel: 'CO₂ Sot',
    treeEquivalent: 'Ekuivalent Pemësh',
    photoUploadSuccess: 'Foto u ngarkua me sukses!',
    photoUploadError: 'Gabim gjatë ngarkimit',
    uploadLogo: 'Ngarko Logo',
    goBack: 'Kthehu',
    productionByCompanies: 'Production by companies',
    hold3sForColor: 'Mbaj 3s mbi grafik për ndërruar ngjyrën',
    weatherStation: 'Stacioni i Motit (Solar)',
    radiation: 'Rrezatimi (GHI)',
    tempAmbient: 'Temp. ambient',
    tempModule: 'Temp. modul',
    wind: 'Era',
    humidityPoa: 'Lagështia · POA (rrafshi i paneleve)',

    // Devices
    allDevices: 'Të Gjitha Pajisjet',
    inverterBattery: 'Inverter dhe Bateri',
    ems: 'EMS (Njehsor Energjie)',
    addDevice: 'Shto Pajisje',
    deviceData: 'Të dhënat e pajisjes',
    noDevices: 'Nuk ka pajisje',
    updated1min: 'Updated 1 minute ago',
    todayPvYield: 'Today PV Yield',
    totalPvYield: 'Total PV Yield',
    detailedParams: 'Detailed Parameters',
    acInfo: 'AC Information',
    analysisGraph: 'Analysis Graph',
    dayLabel: 'Dita',
    weekLabel: 'Java',
    monthLabel: 'Muaji',
    yearLabel: 'Viti',
    lifetime: 'Gjithë Koha',
    totalLabel: 'Total',
    co2Label: 'CO₂',
    edit3s: '3s edit',
    editDevice: 'Ndrysho Pajisje',
    typeRequired: 'Lloji *',
    idRequired: 'ID *',
    select: 'Zgjidh...',
    brand: 'Brendi',
    selectBrand: 'Zgjidh brendin...',
    model: 'Modeli',
    ipAddress: 'IP Adresa',
    dataLoggerRequired: 'Data Logger *',
    powerKw: 'Fuqia (kW) *',
    port: 'Port',
    powerDisplayUnit: 'Shfaqja (MW ose kW)',
    unitId: 'Unit ID',
    photo: 'Foto',
    uploadPhoto: 'Ngarko Foto',
    uploadPhotoShort: '📷 Ngarko Foto',
    selectFile: 'Zgjidh skedar – Ngarko Foto',
    saving: 'Duke ruajtur...',
    idOnRaspberry: 'ID në Raspberry',
    power: 'Fuqia',
    noEdgeData: 'Nuk ka të dhëna edge ende.',
    confirmDeleteDatalogger: 'A je i sigurt? Data Logger dhe të gjithë inverterët/energy meterët e lidhur do të fshihen.',
    confirmDeleteDevice: 'A je i sigurt qe do me fshi pajisjen?',
    deviceDeleted: 'Pajisja u fshi!',
    connectionFailed: 'Lidhja me serverin dështoi...',
    deleteError: 'Gabim gjatë fshirjes',
    selectCompanyRequired: 'Zgjidh një kompani!',
    selectDataLoggerRequired: 'Zgjidh Data Logger!',
    deviceUpdated: 'Pajisja u përditësua!',
    deviceAdded: 'Pajisja u shtua!',
    photoNotLoggedIn: 'Foto: nuk je i kyçur ose token i skaduar. Dil dhe kyçu përsëri.',
    deviceTypeRequired: 'Lloji i Pajisjes *',
    selectType: 'Zgjidh llojin...',
    selectInverter: 'Inverter',
    selectEnergyMeter: 'Energy Meter',
    optional: 'opsionale',
    serialPathRtu: 'Port serial në Raspberry (RS-485)',
    commHintDatalogger: 'Modbus TCP — IP dhe port të logger-it.',
    commHintEnergyMeter: 'Schneider/Siemens: zakonisht Modbus TCP (IP + port 502).',
    commHintChintEnergyMeter:
      'Energy Meter (DTSU666/DSSU666): lidhja është RS-485 në Raspberry; vendos portin serial (p.sh. /dev/ttyS1). Të dhënat sinkronizohen me Pi si pajisjet e tjera.',
    commHintKacoInverter: 'KACO: me RS-485 vendos serial_path; për TCP përdor IP e logger-it.',
    commHintModbusTcpHuaweiGrowatt: 'Modbus TCP përmes Data Logger.',
    commHintInverterOtherBrand: 'Modbus TCP — IP dhe port nga konfigurimi.',
    chintSerialPathRequired: 'Për Energy Meter (profili RS-485) duhet porti serial në Raspberry (p.sh. /dev/ttyS1).',

    // Alarms
    alarmSystem: 'Sistemi i Alarmeve',
    activeAlarms: 'Alarmet aktive',
    activeAlarmsList: 'Lista e alarmeve aktive në kohë reale',
    statusFromPi: 'Statusi nga Pi',
    alarmsFromInverters: 'Alarmet nga inverterët (Pi)',
    history: 'Historiku',
    alarmHistory: 'Historiku i alarmeve të mëparshme',
    notifications: 'Njoftimet',
    registerNotif: 'Regjistro email & SMS për njoftime',
    reportsSection: 'Raporte',
    alarmReports: 'Raporte të detajuara për alarme',
    activeOnly: 'Vetëm aktive',
    allDevicesFilter: 'Të gjitha pajisjet',
    noAlarms: 'Nuk ka alarme.',
    fromPi: 'Nga Pi',
    acknowledge: 'Pranoj',
    alarmStatusFromPi: 'Statusi i alarmeve nga çdo inverter (të dhënat e fundit nga Pi).',
    noInvertersData: 'Nuk ka inverterë ose nuk ka të dhëna.',
    noAlarmList: 'Nuk ka listë alarmesh.',
    noHistoricalData: 'Nuk ka të dhëna historike.',
    updatedLabel: 'Përditësuar',
    acknowledged: 'Pranuar',
    email: 'Email',
    emailPlaceholder: 'email@shembull.com',
    companyOptional: 'Kompani (opsional)',
    all: 'Të gjitha',
    registerNotifications: 'Regjistro njoftime',
    myRegistrations: 'Regjistrimet e mia',
    noRegistrations: 'Nuk keni regjistrime.',
    alarmReportsHint: 'Raporte të detajuara për alarme dhe energji mund të gjenerohen nga faqja Raportet.',
    openReports: 'Hap Raportet',
    registerError: 'Gabim gjatë regjistrimit.',

    // Reports
    reportsTitle: 'Raportet',
    reportsSubtitle: 'Gjenero dhe eksporto raporte të energjisë',
    generateReport: 'Gjenero Raport',
    totalReports: 'Total Raporte',
    daily: 'Ditore',
    monthly: 'Mujore',
    yearly: 'Vjetore',
    noReportsGenerated: 'Nuk ka raporte të gjeneruara',
    generateFirstReport: 'Gjeneroni raportin e parë për të parë statistikat',
    productionLabel: 'Prodhimi',
    pvNowShort: 'PV tani',
    consumption: 'Konsumi',
    sold: 'E Shitur',
    revenue: 'Të Ardhura',
    pdf: 'PDF',
    generateNewReport: 'Gjenero Raport të Ri',
    reportType: 'Tipi i Raportit',
    startDate: 'Fillimi',
    endDate: 'Fundi',
    generating: 'Duke gjeneruar...',
    generate: 'Gjenero',
    reportGenerated: 'Raporti u gjenerua.',
    reportError: 'Gabim gjatë gjenerimit të raportit.',
    reportAllCompanies: 'Të gjitha kompanitë (raport i përbashkët)',
    reportAllCompaniesMyAccess: 'Të gjitha kompanitë ku kam qasje',
    reportFleetGenerated: 'Raporti i përbashkët për të gjitha kompanitë u gjenerua.',
    reportFleetCompanyLabel: 'Të gjitha kompanitë',
    reportFleetPdfSectionsHint: 'PDF me seksione për çdo kompani',
    reportFleetByCompanyMwh: 'Prodhimi sipas kompanive (MWh)',
    reportFleetTableCompany: 'Kompania',
    reportFleetTableMwh: 'Prodhimi (MWh)',
    reportFleetTableTotal: 'Total',
    reportGridExportKwhLabel: 'Eksport',
    reportGridImportKwhLabel: 'Import',
    reportFleetTableExportKwh: 'Eksport',
    reportFleetTableImportKwh: 'Import',
    pvFleetAllCompanies: 'Të gjitha',
    pvFleetEnergyShort: 'Të gjitha kompanit',
    pvFleetBackToDashboard: 'Kthehu te ballina',
    reportsBulkAllOk: 'U gjeneruan {{n}} raporte (një për çdo kompani).',
    reportsBulkNone: 'Nuk u gjenerua asnjë raport.',
    reportsBulkPartialOk: 'U gjeneruan {{ok}} nga {{total}} raporte; disa kompani dështuan.',
    deleteReport: 'Fshi',
    deleteReportDialogTitle: 'Fshirja e raportit',
    confirmDeleteReport: 'Jeni të sigurt që doni të fshini këtë raport?',
    reportDeleted: 'Raporti u fshi.',
    reportDeleteError: 'Gabim gjatë fshirjes së raportit.',
    reportsFilterListPeriod: 'Filtro sipas periudhës së raportit',
    reportsSearchPlaceholder: 'Kërko (tipi, kompani, data…)',
    reportsClearFilters: 'Pastro filtrat',
    reportsNoFilterResults: 'Nuk ka raporte që përputhen me filtrat.',
    dailyReport: 'Ditor',
    weeklyReport: 'Javor',
    monthlyReport: 'Mujor',
    yearlyReport: 'Vjetor',
    companyLabel: 'Kompania',
    energyReport: 'Raport i Energjisë',
    period: 'Periudha',
    metric: 'Metrika',
    value: 'Vlera',
    totalProductionLabel: 'Prodhimi Total',
    totalConsumption: 'Konsumi Total',
    energySold: 'Energjia e Shitur',
    totalRevenue: 'Të Ardhurat Totale',
    alarmActive: 'Aktiv',
    alarmInactive: 'Jo aktiv',
    // Kosova
    kosovaTitle: 'Kosova – Të dhënat e fundit',
    checkingConnection: 'Duke kontrolluar lidhjen...',
    kosovaNotConnected: 'Kosova nuk është e lidhur',
    kosovaNotConnectedHint: 'Lidhja me qendrën rajonale të të dhënave në kohë reale është e pamundur për momentin.',
    sshTunnelHint: 'Në VPS ekzekutoni tunelin:',
    kosovaRegionalLinkBanner:
      'Lidhja e shpejtë me qendrën rajonale nuk përgjigjet. Harta dhe listat e mëposhtme ngarkohen nga serveri kryesor; vlerat PV/sot mund të përditësohen me vonesë.',
    inverterLastRead: 'Inverter (leximi i fundit)',
    dataloggerLastRead: 'Data logger (leximi i fundit)',
    energyMeterLastRead: 'Njehsor energjie (leximi i fundit)',
    alarmsLast10: 'Alarmet (10 të fundit)',
    deviceStatus: 'Statusi pajisjes',
    dailyEnergy: 'Energji ditore (kWh)',
    totalEnergy: 'Energji totale',

    // Analysis
    energyManagement: 'Menaxhimi i Energjisë',
    energy: 'Energjia',
    energyAnalysis: 'Analiza e Energjisë',
    consumptionAnalysis: 'Analiza e Konsumit',
    revenueAnalysis: 'Analiza e të Ardhurave',
    benefits: 'Përfitimet',
    selectDates: 'Zgjidh Datat',
    energyBalance: 'Bilanci i Energjisë',
    selfConsumption: 'Vetë-Konsumi',
    exportLabel: 'Eksporti',
    selfSufficiency: 'Vetë-Mjaftueshmëria',
    buyFromGrid: 'Blerja nga Rrjeti',
    supply: 'Furnizimi (kW)',
    usage: 'Përdorimi',
    loads: 'Ngarkesa',
    network: 'Rrjeti',
    solarGen: 'Diellore',
    generation: 'Gjenerimi',
    imported: 'Importuar',
    pvProduced: 'PV Prodhuar',
    discharged: 'Shkarkuar',
    exported: 'Eksportuar',
    consumed: 'Konsumuar',
    charged: 'Ngarkuar',
    selectPeriod: 'Zgjidh Periudhën',
    fromDate: 'Nga Data',
    toDate: 'Deri në Datën',

    // ProductionPlanning
    productionPlanning: 'Planifikimi i Prodhimit',
    selectDate: 'Data (kalendar për historik)',
    selectCompanyForData: 'Zgjidhni një kompani për të parë të dhënat.',
    selectDateAndSearch: 'Zgjidhni një datë (ose Dje) dhe klikoni Kerko.',
    clickSearchHint: 'Klikoni Kerko për të kërkuar të dhënat për {date}.',
    loadingData: 'Duke ngarkuar të dhënat...',
    noEnergyMeters: 'Nuk ka energy meterë për këtë kompani.',
    weatherHint: 'Të dhënat e motit (GHI, temp, erë) do të shfaqen kur instaloni weather station.',
    hour: 'Ora',
    emProduction: 'EM Prodhimi (kWh)',
    dataloggerKwh: 'Datalogger (kWh)',
    difference: 'Ndryshimi (EM−DL)',
    radiationGhi: 'Rrezatimi (GHI) W/m²',
    tempAmbientC: 'Temp. ambient °C',
    tempModuleC: 'Temp. modul °C',
    windSpeed: 'Era (m/s)',
    weatherOnlyHint: 'Vetëm moti (Open-Meteo). Prodhimi do të shfaqet kur instaloni energy meter.',
    emDlHint: 'EM = Energy Meter (pi_energy_meter_readings). DL = Datalogger (pi_datalogger_readings, energy_total_mwh). Ndryshimi = EM − DL (pozitiv = meter më shumë se datalogger, negativ = datalogger më shumë).',
    data: 'Data',
    productionAndWeatherHourly: 'Prodhimi dhe moti për orë (05:00–20:00)',
    planningForecastSubtitle: 'Parashikim (similar-days); prodhimi = modeli, moti = forecast + stacion',
    planningEmptyHint:
      'Për historik: zgjidhni datën (ose Dje) dhe klikoni Kerko. Për parashikim: klikoni Nesër (data e synuar = nesër sipas Europe/Belgrade).',
    planningForecastExportTitle: 'Planifikim — Parashikim',
    planningHistoryExportTitle: 'Planifikim — Eksport',
    forecastSimilarDays: 'Ditë të ngjashme',
    forecastDailyTotal: 'Total ditor (parashikim)',
    planningEmailRecipientsTitle: 'Marrësit e email-it të planifikimit',
    planningEmailRecipientsHint:
      'Zgjidhni përdoruesit që marrin raportin ditor të planifikimit të prodhimit. Cron dërgon vetëm te të zgjedhurit.',
    planningEmailRecipientsNotConfigured:
      'Ende nuk është ruajtur asnjë listë. Deri sa të ruani, cron përdor të gjithë përdoruesit e lidhur me kompaninë.',
    planningEmailRecipientsCheckAll: 'Zgjidh të gjithë',
    planningEmailRecipientsUncheckAll: 'Hiq të gjithë',
    planningEmailRecipientsSearch: 'Kërko përdorues...',
    planningEmailRecipientsAllCompanies: 'Të gjitha kompanitë',
    planningEmailRecipientsSelectedCount: 'Të zgjedhur: {selected} (në listë: {visible})',
    planningEmailRecipientsNoUsers: 'Nuk ka përdorues me email të vlefshëm.',
    planningEmailRecipientsSaved: 'Lista e marrësve u ruajt.',
    planningEmailRecipientsSaveError: 'Ruajtja e listës dështoi.',
    planningEmailRecipientsLoadError: 'Ngarkimi i listës dështoi.',
    planningEmailRecipientsSaveFirst: 'Ruani fillimisht listën e marrësve.',
    planningEmailRecipientsNoneSelected: 'Zgjidhni të paktën një përdorues.',
    planningEmailDispatchNow: 'Dërgo tani',
    planningEmailDispatchDone: 'U dërguan {count} email(e) kompanish.',
    planningEmailDispatchError: 'Dërgimi i email-eve dështoi.',

    // Companies
    companiesTitle: 'Kompanit',
    companiesSubtitle: 'Menaxho kompanitë dhe të dhënat',
    setDashboardPhoto: 'Vendos foton e dashboard-it për të gjitha',
    setting: 'Duke vendosur...',
    addCompany: '+ Shto Kompani',
    totalCompanies: 'Total Kompani',
    noCompaniesRegistered: 'Nuk ka kompani të regjistruara',
    addFirstCompany: 'Shtoni kompaninë e parë për të filluar',
    logo: 'Logo',
    companyName: 'Emri i kompanisë',
    address: 'Adresa',
    phone: 'Telefoni',
    website: 'Website',
    uniqueNr: 'Nr. Unik',
    vatNr: 'Nr. TVSH',
    hold3sForLogo: 'Mbaj shtypur 3 sekonda për të ngarkuar logo (PNG)',
    editCompany: 'Ndrysho Kompaninë',
    addNewCompany: 'Shto Kompani të Re',
    dashboardPhoto: 'Foto e dashboard-it (opsionale)',
    dashboardPhotoHint: 'Çdo kompani e ka foton e vet në faqen e parë (dashboard)...',
    selectDashboardPhoto: 'Zgjidh foton e dashboard-it',
    companyNameRequired: 'Emri i kompanisë *',
    selectPhoto: 'Zgjidh një foto PNG...',
    selectImage: 'Zgjidh Foto',
    pngOnly: 'Lejohet vetëm skedar PNG (.png).',
    confirmDeleteCompany: 'A jeni të sigurt që dëshironi të fshini këtë kompani?',
    confirmSeedDashboardPhotos: 'Vendos foton e dashboard-it (company_comp-frigofood_aa3a78e3) për të gjitha kompanitë? Më vonë mund ta ndryshoni nga modali "Ndrysho Kompaninë".',
    logoUploaded: 'Logo u ngarkua me sukses!',
    uploadError: 'Gabim gjatë ngarkimit',
    imagesOnly: 'Lejohen vetëm imazhe: PNG, JPG, JPEG, WEBP.',
    dashboardPhotoUploaded: 'Fotoja e dashboard-it u ngarkua me sukses!',
    companySaveError: 'Gabim gjatë ruajtjes së kompanisë.',
    deleteCompanyError: 'Gabim gjatë fshirjes së kompanisë.',

    // Users
    usersTitle: 'Përdoruesit',
    addUser: '+ Shto Përdorues',
    ensureBackendRunning: 'Sigurohuni që backend-i (FastAPI) është i ndezur në portin 8000.',
    tryAgain: 'Provë përsëri',
    closeMessage: 'Mbylle',
    closeMessageAria: 'Mbylle mesazhin',
    name: 'Emri',
    usernameLabel: 'Username',
    emailLabel: 'Email',
    companyLabelUsers: 'Kompania',
    editUser: 'Ndrysho Përdoruesin',
    addNewUser: 'Shto Përdorues të Ri',
    fullName: 'Emër Mbiemër',
    fullNameAlt: 'Emri Mbiemri',
    passwordOptional: 'Fjalëkalimi (opsional)',
    role: 'Role',
    navigation: 'Navigimi',
    selectCompanyUsers: 'Zgjidh Kompanin',
    allowedNavigation: 'Navigimi i Lejuar',
    none: 'Asnjë',
    companiesCount: 'kompani',
    pages: 'faqe',
    allOption: 'Të gjitha',
    confirmDeleteUser: 'A jeni të sigurt që dëshironi të fshini këtë përdorues?',
    saveError: 'Gabim gjatë ruajtjes.',
    deleteUserError: 'Gabim gjatë fshirjes.',

    // DataLoggerDetail
    activePower: 'Active Power',
    reactivePower: 'Reactive Power',
    powerFactor: 'Power Factor (PF)',
    energyToday: 'Energy (Today)',
    totalEnergyYield: 'Total Energy Yield',
    fault: 'Fault',
    standby: 'Standby',
    totalProductionLabel: 'Prodhimi Total',
    deviceInfo: 'Device Information',
    modelLabel: 'Model',
    ipLabel: 'IP',
    portLabel: 'Port',
    totalInverter: 'Total Inverter',
    details: 'Details',
    realTime: 'Real Time',

    // InverterDetail
    inverterNotFound: 'Inverteri nuk u gjet',
    inverterDetails: 'Detajet e Inverterit',
    statusAndEnergy: 'Statusi & Energjia',
    power: 'Fuqia',
    pvVoltage: 'Tensioni PV',
    pvCurrent: 'Rryma PV',
    gridAndPhase: 'Rrjeti & Faza',
    system: 'Sistemi',
    pvPower: 'Fuqia PV',
    todayPvYield: 'Prodhimi sot PV',
    totalPvYield: 'Prodhimi total PV',
    monthlyPvYield: 'Prodhimi mujor PV',
    energyAnalysis: 'Analiza e Energjisë',
    details: 'Detajet',
    realTime: 'Kohë Reale',
    alarms: 'Alarmet',
    realtimeCurve: 'Lakorja në kohë reale',
    deviceStatus: 'Statusi i pajisjes',
    energyYieldCurrentDay: 'Energjia e ditës aktuale',
    totalEnergyYield: 'Energjia totale',
    reducedCo2Emission: 'CO₂ i reduktuar',
    dcPower: 'Fuqia DC',
    activePower: 'Fuqia aktive',
    reactivePower: 'Fuqia reaktive',
    powerFactor: 'Faktori i fuqisë',
    gridAbBcCaVoltage: 'Tensioni rrjeti AB/BC/CA',
    gridAbcPhaseCurrent: 'Rryma fazore A/B/C',
    todayPeakActivePower: 'Fuqia kulmore sot',
    gridFrequency: 'Frekuenca e rrjetit',
    locking: 'Kyçja',
    cabinetTemperature: 'Temp. kabineti',
    startupTime: 'Koha e fillimit',
    shutdownTime: 'Koha e ndaljes',
    collectDspData: 'Mbledhja e të dhënave DSP',
    activePowerAdjustment: 'Rregullimi i fuqisë aktive',
    reactivePowerAdjustment: 'Rregullimi i fuqisë reaktive',
    pv18Voltage: 'PV1-8 tension',
    pv916Voltage: 'PV9-16 tension',
    pv1724Voltage: 'PV17-24 tension',
    pv2528Voltage: 'PV25-28 tension',
    pv18Current: 'PV1-8 rrymë',
    pv916Current: 'PV9-16 rrymë',
    pv1724Current: 'PV17-24 rrymë',
    pv2528Current: 'PV25-28 rrymë',
    allDevices: 'Të Gjitha Pajisjet',
    inverterTab: 'Inverter',
    emsTab: 'EMS',
    noAlarmsInverter: 'Nuk ka alarme.',

    // EnergyMeterDetail
    energyMeterNotFound: 'Njehsor energjie nuk u gjet',
    alarmHistoryLabel: 'Historiku i Alarmave',
    activeAlarmsLabel: 'Alarmet Aktive',
    noActiveAlarms: 'Nuk ka alarme aktive.',
    noAlarms: 'Nuk ka alarme.',
    activePowerReal: 'Fuqia Aktive (Fuqia Reale)',
    todayEnergy: 'Energjia Sot',
    monthlyEnergy: 'Energjia Mujore (1–31)',
    totalEnergyLabel: 'Energjia Totale',
    chintCardProduction: 'Prodhimi',
    chintCardLoad: 'Ngarkesa',
    chintCardImport: 'Import',
    chintCardExport: 'Eksport',
    meterDetails: 'Detajet e Njehsorit',
    energyAnalysisLabel: 'Analiza e Energjisë',
    emChartTimeLabel: 'Koha',
    emSeriesSystemProduction: 'Prodhim sistemi',
    emSeriesSolarProduction: 'Prodhim solar',
    emSeriesLoadConsumption: 'Konsum ngarkese',
    emSeriesSelfConsumption: 'Vetë-konsum',
    emSeriesExportToGrid: 'Eksport në rrjet',
    emSeriesImportFromGrid: 'Import nga rrjeti',
    emSeriesCharged: 'E ngarkuar (bateri)',
    emSeriesDischarged: 'E shkarkuar (bateri)',
    emSystemProductionTotal: 'Prodhimi i sistemit:',
    emLoadConsumptionTotal: 'Konsumi i ngarkesës:',
    inOut: 'Hy-Dil',
    photoUpload: 'Ngarko Foto',
    photoUploadFor: 'Ngarko Foto për',
    selectPhoto: 'Zgjidh Foto',
    exportLabel: 'Eksport',
    totalLabel: 'Total',
    emSectionPower: 'Fuqia',
    emSectionEnergy: 'Energjia',
    emSectionVoltage: 'Tensioni',
    emSectionCurrent: 'Rryma',
    emSectionFrequency: 'Frekuenca',
    emSectionDemand: 'Kërkesa (Peak)',
    emSectionAdvanced: 'Avancuar',
    digitalIO: 'I/O Digjitale',
    inputs: 'Inpute',
    outputs: 'Outpute (mban >5s për shkrim)',
    figureScheme: 'Figurë / Skemë',
    verifyPayload: 'Verifiko payload (raw nga API)',
    writeDO: 'Shkruaj DO1/DO2',
    confirmStopStart: 'A je i sigurt? Don me ndal apo me dhez?',
    send: 'Dërgo',

    // DetailedParameters / Inverter Param Sections
    detailedParameters: 'Parametrat e Detajuar',
    pvInfo: 'Informacioni PV',
    voltage: 'Tensioni (V)',
    currentLabel: 'Rryma (A)',
    powerLabel: 'Fuqia (kW)',
    acInfo: 'Informacioni AC',
    frequency: 'Frekuenca (Hz)',
    gridInfo: 'Informacioni i Rrjetit',
    gridStatus: 'Statusi i Rrjetit',
    loadInfo: 'Informacioni i Ngarkesës',
    gridPower: 'Fuqia e Rrjetit',
    acVoltage: 'Tensioni AC',
    acCurrent: 'Rryma AC',
    acFrequency: 'Frekuenca AC',
    loadPower: 'Fuqia e Ngarkesës',
    loadCurrent: 'Rryma e Ngarkesës',
    pv1Voltage: 'Tensioni PV1',
    pv1Current: 'Rryma PV1',
    pv2Voltage: 'Tensioni PV2',
    pv2Current: 'Rryma PV2',
    dlInputPowerDc: 'Fuqia Hyrëse / DC',
    dlGridPhaseCurrents: 'Rrymat Fazore të Rrjetit',
    dlLockStatus: 'Statusi i Kyçjes',
    dlReactiveAdjustmentLimits: 'Kufijtë e Rregullimit Reaktiv',
    dlActiveAdjustmentLimits: 'Kufijtë e Rregullimit Aktiv',
    dlPvReactiveLimits: 'Kufijtë Reaktivë PV',
    dlEssReactiveLimits: 'Kufijtë Reaktivë ESS',
    dlPvActiveLimit: 'Kufiri Aktiv PV',
    dlEssPeaks: 'Kulmet ESS',
    dlApiOverrideStatuses: 'Statuset e Anashkalimit të API',
    dlRemoteScheduling: 'Planifikimi nga largësia',
    dlKpi: 'KPI',
    dlActivePower: 'Fuqia aktive',
    dlDcPower: 'Fuqia DC',
    dlInputPowerKw: 'Fuqia hyrëse (kW)',
    dlDcCurrentA: 'Rryma DC (A)',
    dlGridAPhaseCurrent: 'Rryma fazore A (A)',
    dlGridBPhaseCurrent: 'Rryma fazore B (A)',
    dlGridCPhaseCurrent: 'Rryma fazore C (A)',
    dlLockStatusLabel: 'Statusi i kyçjes',
    dlReducedCo2Kg: 'CO₂ i reduktuar (kg)',
    dlMaxReactiveAdj: 'Vlera maks. për rregullim reaktiv (kVar)',
    dlMinReactiveAdj: 'Vlera min. për rregullim reaktiv (kVar)',
    dlMaxActiveAdj: 'Vlera maks. për rregullim aktiv (kW)',
    dlMinActiveAdj: 'Vlera min. për rregullim aktiv (kW)',
    dlPvReactiveMax: 'Vlera më e lartë reaktive PV (kVar)',
    dlPvReactiveMin: 'Vlera më e ulët reaktive PV (kVar)',
    dlEssReactiveMax: 'Vlera më e lartë reaktive ESS (kVar)',
    dlEssReactiveMin: 'Vlera më e ulët reaktive ESS (kVar)',
    dlPvActiveMax: 'Vlera më e lartë aktive PV (kW)',
    dlEssDischargeMax: 'Fuqia maksimale shkarkimi ESS (kW)',
    dlEssChargeMax: 'Fuqia maksimale ngarkimi ESS (kW)',
    dlApiActiveOverride: 'API aktive me përparësi të ulët të anashkaluara',
    dlApiReactiveOverride: 'API reaktive me përparësi të ulët të anashkaluara',
    dlRemoteSchedP: 'Planifikim komunikimi nga largësia (P)',
    dlRemoteSchedQ: 'Planifikim komunikimi nga largësia (Q)',
    dailyFeedIn: 'Daily feed-in energy',
    totalFeedIn: 'Total feed-in energy',
    dailyPurchased: 'Daily purchased energy',
    totalPurchased: 'Total purchased energy',
    feedInPower: 'Feed-in power',
    purchasedPower: 'Purchased power',
    loadInfo: 'Load Information',
    dailyLoadConsumption: 'Daily Load Consumption',
    totalLoadConsumption: 'Total Load Consumption',
    totalLoadPower: 'Total Load Power',
    gridLoadPower: 'Grid Load Power',
    epsLoadPower: 'EPS Load Power',
  },
  en: {
    logout: 'Logout',
    more: 'More',
    home: 'Dashboard',
    devices: 'Devices',
    alarms: 'Alarms',
    reports: 'Reports',
    kosova: 'Kosova',
    fleet_overview: "Live View",
    analysis: 'Analysis',
    analizat: 'Analysis',
    planning: 'Planning',
    control: 'Control',
    companies: 'Companies',
    users: 'Users',
    une: 'Me',
    navKosova: 'KOSOVA',
    systemSettings: 'System settings',
    connections: 'Connections',
    about: 'About',
    aboutApp: 'About this app',
    connectionsHint: 'Connection status and integration documentation.',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    passwordChanged: 'Password updated.',
    passwordChangeError: 'Could not change password.',
    passwordMismatch: 'New passwords do not match.',
    languageLabel: 'Language',
    themeLabel: 'Appearance',
    themeDark: 'Dark',
    themeLight: 'Light',

    loginTitle: 'Login',
    loginSubtitle: 'Enter your credentials to continue',
    username: 'Username',
    passwordLabel: 'Password',
    rememberCreds: 'Remember credentials',
    loginBtn: 'Login',
    loggingIn: 'Logging in...',
    errorNetwork: 'Connection to server failed.',
    errorLogin: 'Login error. Please try again.',
    toggleThemeLabel: 'Toggle light/dark',

    loading: 'Loading...',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    apply: 'Apply',
    search: 'Search',
    back: 'Back',
    confirm: 'Are you sure?',
    errorGeneric: 'Error',
    password: 'Password',
    confirmCheck: 'Confirm',
    execute: 'Execute',
    sending: 'Sending...',
    noCompanies: 'No companies',
    selectCompany: 'Select company',
    selectCompanyFirst: 'Select a company.',
    company: 'Company',
    dataLogger: 'Data Logger',
    dataLoggers: 'Data Logger',
    inverter: 'Inverter',
    inverters: 'Inverters',
    energyMeter: 'Energy Meter',
    energyMeters: 'Energy Meters',
    status: 'Status',
    type: 'Type',
    actions: 'Actions',
    online: 'Online',
    offline: 'Offline',
    partial: 'Partial',
    normal: 'Normal',
    active: 'Active',
    inactive: 'Inactive',
    total: 'Total',
    day: 'Day',
    month: 'Month',
    year: 'Year',
    week: 'Week',
    today: 'Today',
    yesterday: 'Yesterday',
    tomorrow: 'Tomorrow',
    noData: 'No data',

    emPowerFlowTitle: 'Energy flow',
    emPowerFlowPpv: 'Ppv',
    emPowerFlowBattery: 'Discharging power',
    emPowerFlowLoad: 'Load power',
    emPowerFlowGridImport: 'Import',
    emPowerFlowExportTag: 'EXPORT',
    emPowerFlowUnitKw: 'kW',
    emPowerFlowUnitMw: 'MW',

    controlDatalogger: 'Control Datalogger',
    controlSubtitle: 'Select company, data logger and control.',
    selectDataLogger: 'Select data logger',
    start: 'Start',
    stop: 'Stop',
    shutdown: 'Shutdown',
    enable: 'Enable',
    controlLabel: 'Control',
    limitProduction: 'Limit production',
    reactivePower: 'Reactive Power (kVar)',
    powerFactor: 'Power Factor (cosφ)',
    reactiveMode: 'Reactive mode (Q / PF)',
    current: 'Current',
    applyQ: 'Apply Q',
    applyPF: 'Apply PF',
    applyMode: 'Apply mode',
    mode: 'Mode',
    disabled: 'Disabled',
    percent: 'Percent',
    kw: 'kW',
    qKvar: 'Q (kVar)',
    pfCos: 'PF (cosφ)',
    voltVar: 'Volt-Var',
    voltWatt: 'Volt-Watt',
    inverterList: 'Inverter list',
    selectAll: 'Select All',
    noInverters: 'No inverters.',
    selectDataLoggerFirst: 'Select data logger.',

    noCompaniesDash: 'No companies',
    noDataLoggers: 'No Data Loggers',
    addDataLoggerHint: 'Add a data logger for this company',
    co2Today: 'CO2 Today',
    pvNow: 'PV Now',
    pvToday: 'PV Today',
    pvYesterday: 'PV Yesterday',
    todayProfit: "Today's Profit",
    updated: 'Updated',
    justNow: 'just now',
    onGrid: 'ON GRID',
    offGrid: 'OFF GRID',
    flowing: 'flowing',
    production7days: 'Production 7 days (kWh)',
    energyFlow: 'Energy Flow',
    pv: 'PV',
    load: 'Load',
    grid: 'Grid',
    production: 'Production',
    solar: 'Solar',
    pvPower: 'PV Power',
    capacity: 'Capacity',
    dayShort: 'Day',
    monthShort: 'Month',
    yearShort: 'Year',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    totalProduction: 'Total Production',
    urgentAlarms: 'Urgent alarms',
    recentAlarms: 'Recent alarms',
    environmentalImpact: 'Environmental Impact',
    co2TodayLabel: 'CO₂ Today',
    treeEquivalent: 'Tree Equivalent',
    photoUploadSuccess: 'Photo uploaded successfully!',
    photoUploadError: 'Upload error',
    uploadLogo: 'Upload Logo',
    goBack: 'Go Back',
    productionByCompanies: 'Production by companies',
    hold3sForColor: 'Hold 3s on chart to change color',
    weatherStation: 'Weather Station (Solar)',
    radiation: 'Radiation (GHI)',
    tempAmbient: 'Temp. ambient',
    tempModule: 'Temp. module',
    wind: 'Wind',
    humidityPoa: 'Humidity · POA (panel plane)',

    allDevices: 'All Devices',
    inverterBattery: 'Inverter & Battery',
    ems: 'EMS (Energy Meter)',
    addDevice: 'Add Device',
    deviceData: 'Device data',
    noDevices: 'No devices',
    updated1min: 'Updated 1 minute ago',
    todayPvYield: 'Today PV Yield',
    totalPvYield: 'Total PV Yield',
    detailedParams: 'Detailed Parameters',
    acInfo: 'AC Information',
    analysisGraph: 'Analysis Graph',
    dayLabel: 'Day',
    weekLabel: 'Week',
    monthLabel: 'Month',
    yearLabel: 'Year',
    lifetime: 'Lifetime',
    totalLabel: 'Total',
    co2Label: 'CO₂',
    edit3s: '3s edit',
    editDevice: 'Edit Device',
    typeRequired: 'Type *',
    idRequired: 'ID *',
    select: 'Select...',
    brand: 'Brand',
    selectBrand: 'Select brand...',
    model: 'Model',
    ipAddress: 'IP Address',
    dataLoggerRequired: 'Data Logger *',
    powerKw: 'Power (kW) *',
    port: 'Port',
    powerDisplayUnit: 'Display (MW or kW)',
    unitId: 'Unit ID',
    photo: 'Photo',
    uploadPhoto: 'Upload Photo',
    uploadPhotoShort: '📷 Upload Photo',
    selectFile: 'Select file – Upload Photo',
    saving: 'Saving...',
    idOnRaspberry: 'ID on Raspberry',
    power: 'Power',
    noEdgeData: 'No edge data yet.',
    confirmDeleteDatalogger: 'Are you sure? Data Logger and all connected inverters/energy meters will be deleted.',
    confirmDeleteDevice: 'Are you sure you want to delete this device?',
    deviceDeleted: 'Device deleted!',
    connectionFailed: 'Connection to server failed...',
    deleteError: 'Delete error',
    selectCompanyRequired: 'Select a company!',
    selectDataLoggerRequired: 'Select Data Logger!',
    deviceUpdated: 'Device updated!',
    deviceAdded: 'Device added!',
    photoNotLoggedIn: 'Photo: you are not logged in or token expired. Logout and login again.',
    deviceTypeRequired: 'Device Type *',
    selectType: 'Select type...',
    selectInverter: 'Inverter',
    selectEnergyMeter: 'Energy Meter',
    optional: 'optional',
    serialPathRtu: 'Serial port on Raspberry (RS-485)',
    commHintDatalogger: 'Modbus TCP — data logger IP and port.',
    commHintEnergyMeter: 'Schneider/Siemens: usually Modbus TCP (IP + port 502).',
    commHintChintEnergyMeter:
      'Energy Meter (DTSU666/DSSU666): RS-485 on the Raspberry; set the serial device (e.g. /dev/ttyS1). Data syncs to the Pi like other devices.',
    commHintKacoInverter: 'KACO: with RS-485 set serial_path; for TCP use the logger IP.',
    commHintModbusTcpHuaweiGrowatt: 'Modbus TCP via Data Logger.',
    commHintInverterOtherBrand: 'Modbus TCP — IP and port from configuration.',
    chintSerialPathRequired: 'Energy Meter (RS-485 profile) requires the Raspberry serial port (e.g. /dev/ttyS1).',

    alarmSystem: 'Alarm System',
    activeAlarms: 'Active alarms',
    activeAlarmsList: 'List of active alarms in real time',
    statusFromPi: 'Status from Pi',
    alarmsFromInverters: 'Alarms from inverters (Pi)',
    history: 'History',
    alarmHistory: 'History of previous alarms',
    notifications: 'Notifications',
    registerNotif: 'Register email & SMS for notifications',
    reportsSection: 'Reports',
    alarmReports: 'Detailed reports for alarms',
    activeOnly: 'Active only',
    allDevicesFilter: 'All devices',
    noAlarms: 'No alarms.',
    fromPi: 'From Pi',
    acknowledge: 'Acknowledge',
    alarmStatusFromPi: 'Alarm status from each inverter (latest data from Pi).',
    noInvertersData: 'No inverters or no data.',
    noAlarmList: 'No alarm list.',
    noHistoricalData: 'No historical data.',
    updatedLabel: 'Updated',
    acknowledged: 'Acknowledged',
    email: 'Email',
    emailPlaceholder: 'email@example.com',
    companyOptional: 'Company (optional)',
    all: 'All',
    registerNotifications: 'Register notifications',
    myRegistrations: 'My registrations',
    noRegistrations: 'No registrations.',
    alarmReportsHint: 'Detailed reports for alarms and energy can be generated from the Reports page.',
    openReports: 'Open Reports',
    registerError: 'Registration error.',

    reportsTitle: 'Reports',
    reportsSubtitle: 'Generate and export energy reports',
    generateReport: 'Generate Report',
    totalReports: 'Total Reports',
    daily: 'Daily',
    monthly: 'Monthly',
    yearly: 'Yearly',
    noReportsGenerated: 'No reports generated',
    generateFirstReport: 'Generate the first report to see statistics',
    productionLabel: 'Production',
    pvNowShort: 'PV now',
    consumption: 'Consumption',
    sold: 'Sold',
    revenue: 'Revenue',
    pdf: 'PDF',
    generateNewReport: 'Generate New Report',
    reportType: 'Report Type',
    startDate: 'Start',
    endDate: 'End',
    generating: 'Generating...',
    generate: 'Generate',
    reportGenerated: 'Report generated.',
    reportError: 'Error generating report.',
    reportAllCompanies: 'All companies (single combined report)',
    reportAllCompaniesMyAccess: 'All companies I have access to',
    reportFleetGenerated: 'Combined report for all companies was generated.',
    reportFleetCompanyLabel: 'All companies',
    reportFleetPdfSectionsHint: 'PDF with one section per company',
    reportFleetByCompanyMwh: 'Production by company (MWh)',
    reportFleetTableCompany: 'Company',
    reportFleetTableMwh: 'Production (MWh)',
    reportFleetTableTotal: 'Total',
    reportGridExportKwhLabel: 'Export',
    reportGridImportKwhLabel: 'Import',
    reportFleetTableExportKwh: 'Export',
    reportFleetTableImportKwh: 'Import',
    pvFleetAllCompanies: 'All',
    pvFleetEnergyShort: 'All companies',
    pvFleetBackToDashboard: 'Back to dashboard',
    reportsBulkAllOk: '{{n}} reports were generated (one per company).',
    reportsBulkNone: 'No reports were generated.',
    reportsBulkPartialOk: 'Generated {{ok}} of {{total}} reports; some companies failed.',
    deleteReport: 'Delete',
    deleteReportDialogTitle: 'Delete report',
    confirmDeleteReport: 'Are you sure you want to delete this report?',
    reportDeleted: 'Report deleted.',
    reportDeleteError: 'Error deleting report.',
    reportsFilterListPeriod: 'Filter by report period',
    reportsSearchPlaceholder: 'Search (type, company, dates…)',
    reportsClearFilters: 'Clear filters',
    reportsNoFilterResults: 'No reports match the filters.',
    dailyReport: 'Daily',
    weeklyReport: 'Weekly',
    monthlyReport: 'Monthly',
    yearlyReport: 'Yearly',
    companyLabel: 'Company',
    energyReport: 'Energy Report',
    period: 'Period',
    metric: 'Metric',
    value: 'Value',
    totalProductionLabel: 'Total Production',
    totalConsumption: 'Total Consumption',
    energySold: 'Energy Sold',
    totalRevenue: 'Total Revenue',
    alarmActive: 'Active',
    alarmInactive: 'In Active',
    kosovaTitle: 'Kosova – Latest data',
    checkingConnection: 'Checking connection...',
    kosovaNotConnected: 'Kosova is not connected',
    kosovaNotConnectedHint: 'The regional real-time data link is temporarily unavailable.',
    sshTunnelHint: 'On VPS run the tunnel:',
    kosovaRegionalLinkBanner:
      'The regional quick-link is not responding. The map and lists below load from the main server; PV / today values may update more slowly.',
    inverterLastRead: 'Inverter (last reading)',
    dataloggerLastRead: 'Data logger (last reading)',
    energyMeterLastRead: 'Energy meter (last reading)',
    alarmsLast10: 'Alarms (last 10)',
    deviceStatus: 'Device status',
    dailyEnergy: 'Daily energy (kWh)',
    totalEnergy: 'Total energy',

    energyManagement: 'Energy Management',
    energy: 'Energy',
    energyAnalysis: 'Energy Analysis',
    consumptionAnalysis: 'Consumption Analysis',
    revenueAnalysis: 'Revenue Analysis',
    benefits: 'Benefits',
    selectDates: 'Select Dates',
    energyBalance: 'Energy Balance',
    selfConsumption: 'Self-Consumption',
    exportLabel: 'Export',
    selfSufficiency: 'Self-Sufficiency',
    buyFromGrid: 'Buy from Grid',
    supply: 'Supply (kW)',
    usage: 'Usage',
    loads: 'Loads',
    network: 'Network',
    solarGen: 'Solar',
    generation: 'Generation',
    imported: 'Imported',
    pvProduced: 'PV Produced',
    discharged: 'Discharged',
    exported: 'Exported',
    consumed: 'Consumed',
    charged: 'Charged',
    selectPeriod: 'Select Period',
    fromDate: 'From Date',
    toDate: 'To Date',

    productionPlanning: 'Production Planning',
    selectDate: 'Date (calendar for history)',
    selectCompanyForData: 'Select a company to view data.',
    selectDateAndSearch: 'Select a date (or Yesterday) and click Search.',
    clickSearchHint: 'Click Search to fetch data for {date}.',
    loadingData: 'Loading data...',
    noEnergyMeters: 'No energy meters for this company.',
    weatherHint: 'Weather data (GHI, temp, wind) will appear when you install weather station.',
    hour: 'Hour',
    emProduction: 'EM Production (kWh)',
    dataloggerKwh: 'Datalogger (kWh)',
    difference: 'Difference (EM−DL)',
    radiationGhi: 'Radiation (GHI) W/m²',
    tempAmbientC: 'Temp. ambient °C',
    tempModuleC: 'Temp. module °C',
    windSpeed: 'Wind (m/s)',
    weatherOnlyHint: 'Weather only (Open-Meteo). Production will appear when you install energy meter.',
    emDlHint: 'EM = Energy Meter (pi_energy_meter_readings). DL = Datalogger (pi_datalogger_readings, energy_total_mwh). Diff = EM − DL (positive = meter more than datalogger, negative = datalogger more).',
    data: 'Date',
    productionAndWeatherHourly: 'Production and weather by hour (05:00–20:00)',
    planningForecastSubtitle: 'Forecast (similar-days); production = model, weather = forecast + station',
    planningEmptyHint:
      'For history: pick a date (or Yesterday) and click Search. For forecast: click Tomorrow (target date = tomorrow in Europe/Belgrade).',
    planningForecastExportTitle: 'Planning — Forecast',
    planningHistoryExportTitle: 'Planning — Export',
    forecastSimilarDays: 'Similar days',
    forecastDailyTotal: 'Daily total (forecast)',
    planningEmailRecipientsTitle: 'Production planning email recipients',
    planningEmailRecipientsHint:
      'Select users who receive the daily production planning report. Cron sends only to selected users.',
    planningEmailRecipientsNotConfigured:
      'No list saved yet. Until you save, cron uses all users linked to each company.',
    planningEmailRecipientsCheckAll: 'Select all',
    planningEmailRecipientsUncheckAll: 'Deselect all',
    planningEmailRecipientsSearch: 'Search users...',
    planningEmailRecipientsAllCompanies: 'All companies',
    planningEmailRecipientsSelectedCount: 'Selected: {selected} (in list: {visible})',
    planningEmailRecipientsNoUsers: 'No users with a valid email.',
    planningEmailRecipientsSaved: 'Recipient list saved.',
    planningEmailRecipientsSaveError: 'Failed to save recipient list.',
    planningEmailRecipientsLoadError: 'Failed to load recipient list.',
    planningEmailRecipientsSaveFirst: 'Save the recipient list first.',
    planningEmailRecipientsNoneSelected: 'Select at least one user.',
    planningEmailDispatchNow: 'Send now',
    planningEmailDispatchDone: 'Sent {count} company email(s).',
    planningEmailDispatchError: 'Failed to send emails.',

    companiesTitle: 'Companies',
    companiesSubtitle: 'Manage companies and data',
    setDashboardPhoto: 'Set dashboard photo for all',
    setting: 'Setting...',
    addCompany: '+ Add Company',
    totalCompanies: 'Total Companies',
    noCompaniesRegistered: 'No companies registered',
    addFirstCompany: 'Add the first company to get started',
    logo: 'Logo',
    companyName: 'Company name',
    address: 'Address',
    phone: 'Phone',
    website: 'Website',
    uniqueNr: 'Unique Nr',
    vatNr: 'VAT Nr',
    hold3sForLogo: 'Hold 3 seconds to upload logo (PNG)',
    editCompany: 'Edit Company',
    addNewCompany: 'Add New Company',
    dashboardPhoto: 'Dashboard photo (optional)',
    dashboardPhotoHint: 'Each company has its own photo on the first page (dashboard)...',
    selectDashboardPhoto: 'Select dashboard photo',
    companyNameRequired: 'Company name *',
    selectPhoto: 'Select a PNG image...',
    selectImage: 'Select Image',
    pngOnly: 'PNG files only (.png).',
    confirmDeleteCompany: 'Are you sure you want to delete this company?',
    confirmSeedDashboardPhotos: 'Set dashboard photo (company_comp-frigofood_aa3a78e3) for all companies? You can change it later from the Edit Company modal.',
    logoUploaded: 'Logo uploaded successfully!',
    uploadError: 'Upload error',
    imagesOnly: 'Only images allowed: PNG, JPG, JPEG, WEBP.',
    dashboardPhotoUploaded: 'Dashboard photo uploaded successfully!',
    companySaveError: 'Error saving company.',

    usersTitle: 'Users',
    addUser: '+ Add User',
    ensureBackendRunning: 'Make sure the backend (FastAPI) is running on port 8000.',
    tryAgain: 'Try again',
    closeMessage: 'Close',
    closeMessageAria: 'Close message',
    name: 'Name',
    usernameLabel: 'Username',
    emailLabel: 'Email',
    companyLabelUsers: 'Company',
    editUser: 'Edit User',
    addNewUser: 'Add New User',
    fullName: 'Full Name',
    fullNameAlt: 'Full Name',
    passwordOptional: 'Password (optional)',
    role: 'Role',
    navigation: 'Navigation',
    selectCompanyUsers: 'Select Company',
    allowedNavigation: 'Allowed Navigation',
    none: 'None',
    companiesCount: 'companies',
    pages: 'pages',
    allOption: 'All',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    saveError: 'Error saving.',
    deleteUserError: 'Error deleting.',

    activePower: 'Active Power',
    reactivePower: 'Reactive Power',
    powerFactor: 'Power Factor (PF)',
    energyToday: 'Energy (Today)',
    totalEnergyYield: 'Total Energy Yield',
    fault: 'Fault',
    standby: 'Standby',
    deviceInfo: 'Device Information',
    modelLabel: 'Model',
    ipLabel: 'IP',
    portLabel: 'Port',
    totalInverter: 'Total Inverter',
    details: 'Details',
    realTime: 'Real Time',

    inverterNotFound: 'Inverter not found',
    inverterDetails: 'Inverter Details',
    statusAndEnergy: 'Status & Energy',
    power: 'Power',
    pvVoltage: 'PV Voltage',
    pvCurrent: 'PV Current',
    gridAndPhase: 'Grid & Phase',
    system: 'System',
    pvPower: 'PV Power',
    todayPvYield: 'Today PV Yield',
    totalPvYield: 'Total PV Yield',
    monthlyPvYield: 'Monthly PV Yield',
    energyAnalysis: 'Energy Analysis',
    details: 'Details',
    realTime: 'Real Time',
    alarms: 'Alarms',
    realtimeCurve: 'Real-time Curve',
    deviceStatus: 'Device status',
    energyYieldCurrentDay: 'Energy yield of current day',
    totalEnergyYield: 'Total energy yield',
    reducedCo2Emission: 'Reduced CO2 emission',
    dcPower: 'DC power',
    activePower: 'Active power',
    reactivePower: 'Reactive power',
    powerFactor: 'Power factor',
    gridAbBcCaVoltage: 'Grid AB/BC/CA voltage',
    gridAbcPhaseCurrent: 'Grid A/B/C phase current',
    todayPeakActivePower: "Today's peak active power",
    gridFrequency: 'Grid frequency',
    locking: 'Locking',
    cabinetTemperature: 'Cabinet temperature',
    startupTime: 'Startup time',
    shutdownTime: 'Shutdown time',
    collectDspData: 'Collect DSP data',
    activePowerAdjustment: 'Active power adjustment',
    reactivePowerAdjustment: 'Reactive power adjustment',
    pv18Voltage: 'PV1-8 voltage',
    pv916Voltage: 'PV9-16 voltage',
    pv1724Voltage: 'PV17-24 voltage',
    pv2528Voltage: 'PV25-28 voltage',
    pv18Current: 'PV1-8 current',
    pv916Current: 'PV9-16 current',
    pv1724Current: 'PV17-24 current',
    pv2528Current: 'PV25-28 current',
    allDevices: 'All Devices',
    inverterTab: 'Inverter',
    emsTab: 'EMS',
    noAlarmsInverter: 'No alarms.',

    energyMeterNotFound: 'Energy Meter not found',
    alarmHistoryLabel: 'Alarm History',
    activeAlarmsLabel: 'Active Alarms',
    noActiveAlarms: 'No active alarms.',
    noAlarms: 'No alarms.',
    activePowerReal: 'Active Power',
    todayEnergy: 'Today Energy',
    monthlyEnergy: 'Monthly Energy (1–31)',
    totalEnergyLabel: 'Total Energy',
    chintCardProduction: 'Production',
    chintCardLoad: 'Load',
    chintCardImport: 'Import',
    chintCardExport: 'Export',
    meterDetails: 'Meter Details',
    energyAnalysisLabel: 'Energy Analysis',
    emChartTimeLabel: 'Time',
    emSeriesSystemProduction: 'System production',
    emSeriesSolarProduction: 'Solar production',
    emSeriesLoadConsumption: 'Load consumption',
    emSeriesSelfConsumption: 'Self-consumption',
    emSeriesExportToGrid: 'Export to grid',
    emSeriesImportFromGrid: 'Import from grid',
    emSeriesCharged: 'Charged',
    emSeriesDischarged: 'Discharged',
    emSystemProductionTotal: 'System production:',
    emLoadConsumptionTotal: 'Load consumption:',
    inOut: 'IN-OUT',
    photoUpload: 'Upload Photo',
    photoUploadFor: 'Upload Photo for',
    selectPhoto: 'Select Photo',
    exportLabel: 'Export',
    totalLabel: 'Total',
    emSectionPower: 'Power',
    emSectionEnergy: 'Energy',
    emSectionVoltage: 'Voltage',
    emSectionCurrent: 'Current',
    emSectionFrequency: 'Frequency',
    emSectionDemand: 'Demand (Peak)',
    emSectionAdvanced: 'Advanced',
    digitalIO: 'Digital I/O',
    inputs: 'Inputs',
    outputs: 'Outputs (hold >5s to write)',
    figureScheme: 'Figure / Scheme',
    verifyPayload: 'Verify payload (raw from API)',
    writeDO: 'Write DO1/DO2',
    confirmStopStart: 'Are you sure? Turn off or on?',
    send: 'Send',

    detailedParameters: 'Detailed Parameters',
    pvInfo: 'PV Information',
    voltage: 'Voltage(V)',
    currentLabel: 'Current(A)',
    powerLabel: 'Power(kW)',
    frequency: 'Frequency(H...',
    gridInfo: 'Grid Information',
    gridStatus: 'Grid Status',
    dailyFeedIn: 'Daily feed-in energy',
    totalFeedIn: 'Total feed-in energy',
    dailyPurchased: 'Daily purchased energy',
    totalPurchased: 'Total purchased energy',
    feedInPower: 'Feed-in power',
    purchasedPower: 'Purchased power',
    loadInfo: 'Load Information',
    dailyLoadConsumption: 'Daily Load Consumption',
    totalLoadConsumption: 'Total Load Consumption',
    totalLoadPower: 'Total Load Power',
    gridLoadPower: 'Grid Load Power',
    epsLoadPower: 'EPS Load Power',

    dlInputPowerDc: 'Input Power DC',
    dlGridPhaseCurrents: 'Grid Phase Currents',
    dlLockStatus: 'Lock Status',
    dlReactiveAdjustmentLimits: 'Reactive Adjustment Limits',
    dlActiveAdjustmentLimits: 'Active Adjustment Limits',
    dlPvReactiveLimits: 'PV Reactive Limits',
    dlEssReactiveLimits: 'ESS Reactive Limits',
    dlPvActiveLimit: 'PV Active Limit',
    dlEssPeaks: 'ESS Peaks',
    dlApiOverrideStatuses: 'API Override Statuses',
    dlRemoteScheduling: 'Remote Scheduling',
    dlKpi: 'KPI',
    dlActivePower: 'Active Power',
    dlDcPower: 'DC Power',
    dlInputPowerKw: 'Input Power (kW)',
    dlDcCurrentA: 'DC Current (A)',
    dlGridAPhaseCurrent: 'Grid A Phase Current (A)',
    dlGridBPhaseCurrent: 'Grid B Phase Current (A)',
    dlGridCPhaseCurrent: 'Grid C Phase Current (A)',
    dlLockStatusLabel: 'Lock Status',
    dlReducedCo2Kg: 'Reduced CO₂ (kg)',
    dlMaxReactiveAdj: 'Max. reactive adjustment (kVar)',
    dlMinReactiveAdj: 'Min. reactive adjustment (kVar)',
    dlMaxActiveAdj: 'Max. active adjustment (kW)',
    dlMinActiveAdj: 'Min. active adjustment (kW)',
    dlPvReactiveMax: 'Highest reactive PV (kVar)',
    dlPvReactiveMin: 'Lowest reactive PV (kVar)',
    dlEssReactiveMax: 'Highest reactive ESS (kVar)',
    dlEssReactiveMin: 'Lowest reactive ESS (kVar)',
    dlPvActiveMax: 'Highest active PV (kW)',
    dlEssDischargeMax: 'ESS Max Discharge (kW)',
    dlEssChargeMax: 'ESS Max Charge (kW)',
    dlApiActiveOverride: 'API active override (lower priority)',
    dlApiReactiveOverride: 'API reactive override (lower priority)',
    dlRemoteSchedP: 'Remote scheduling (P)',
    dlRemoteSchedQ: 'Remote scheduling (Q)',
  },
};
